
import { Component, OnInit, OnDestroy, Input, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';

import { select, Store } from '@ngrx/store';

import * as fromStore from '../store';
import * as fromModels from '../../scp/schools/models';
import { ReportsSchoolSearchResultsRowComponent } from './reports-school-searchresults-row.component';
import { ConfigurationService } from '../../core/services';
//import { ConfigurationState } from '../../core/store/reducers';

@Component({
  selector: 'opus-reports-school-searchresults-page',
  templateUrl: './reports-school-searchresults.component.html',
  })

export class ReportsSchoolSearchResultsComponent implements OnInit, OnChanges, OnDestroy {
  reportSearchResultsState$: Observable<fromStore.ReportsSearchResultsState>;
  embeddedVersion = false;

  alive = true;
  schoolItemForm: FormGroup;
  apiUrl: string;

  private _subscription: Subscription;
  private _searchCriteria: fromModels.SchoolSearchCriteria;
  private _pagingSorting: fromModels.SchoolPagingSorting;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private _store: Store<fromStore.ReportsSchoolsState>,
    private configuration: ConfigurationService,
    private fb: FormBuilder) {
    console.log('ReportsSchoolSearchResultsComponent: constructor().');
  }

  ngOnInit() {
    console.log('ReportsSchoolSearchResultsComponent: ngOnInit().');
    this.reportSearchResultsState$ = null;

    // Get results of search (so our html can populate)
    this.reportSearchResultsState$ = this._store.pipe(select(fromStore.getReportsSchoolSearchState));
    // Grab the current search criteria stored in the state
    console.log(this.reportSearchResultsState$);

    // Grab the current search criteria stored in the state
    console.log(this.reportSearchResultsState$);
    this._subscription = this.reportSearchResultsState$.subscribe(s => {
      this._searchCriteria = s.searchCriteria;
      this._pagingSorting = s.pagingSorting;
    });

    // If query params are changed, process them
    this.route.queryParams.subscribe(val => {
      this._store.dispatch(new fromStore.ProcessReportQueryString(this.router.url));
    });

    this.createForm();
  }

  ngOnChanges() {

  }

  ngOnDestroy() {
    this.alive = false;
  }

  createForm() {
    this.reportSearchResultsState$.subscribe(i => {
      if (i.searchResults != null) {
        const schoolResultsData = this.fb.array([]);
        for (let ind = 0; ind < i.searchResults.length; ind++) {
          const itm = ReportsSchoolSearchResultsRowComponent.BuildItem(i.searchResults[ind]);
          schoolResultsData.push(itm);
        }

        this.schoolItemForm = null;
        this.schoolItemForm = this.fb.group({
          schoolResultsData,
        });
      }
    })
  }

  nextPage() {
    console.log('ReportsSchoolSearchResultsComponent: nextPage().');
    this.schoolItemForm.reset();

    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.NextPage(this._searchCriteria, this._pagingSorting));
  }

  prevPage() {
    console.log('ReportsSchoolSearchResultsComponent: prevPage().');
    this.schoolItemForm.reset();

    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.PrevPage(this._searchCriteria, this._pagingSorting));
  }

  setPageSize(pageSize: number) {
    console.log('ReportsSchoolSearchResultsComponent: setPageSize().');
    this.schoolItemForm.reset();

    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.SetPageSize(pageSize, this._searchCriteria));
  }

  lastPage() {
    console.log('ReportsSchoolSearchResultsComponent: lastPage().');
    this.schoolItemForm.reset();

    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.LastPage(this._searchCriteria, this._pagingSorting));
  }

  firstPage() {
    console.log('ReportsSchoolSearchResultsComponent: firstPage().');
    this.schoolItemForm.reset();

    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.FirstPage(this._searchCriteria, this._pagingSorting));
  }

  sortBy(column: string) {
    console.log('ReportsSchoolSearchResultsComponent: sortBy().');
    this.schoolItemForm.reset();

    // Run the search again with the new parameters
    this._store.dispatch(new fromStore.SortBy(column, this._searchCriteria, this._pagingSorting));
  }

  get schoolItemForms(): FormArray {
    return this.schoolItemForm.get('schoolResultsData') as FormArray;
  }

  onSelectAll(e: Event) {
    console.log('ReportsSchoolSearchResultsComponent.onSelectAll(): ', e);

    const selected: boolean = (e.target as HTMLInputElement).checked;

    this.schoolItemForms.controls.forEach((g: FormGroup) => {
      const c = g.controls.isSelected;

      if (c.value != selected) {
        c.setValue(selected);
      }
    });
  }

  generateReports(e: Event) {
    this.schoolItemForms.controls.forEach((g: FormGroup) => {
      const c = g.controls.isSelected;

      if (c.value == true) {
        const id = g.controls.id.value;
        var url = "/reports/school-preferences-print/" + id;
        var msg = "Generate the report";
        window.open(url, '_blank');
      }
    });
  }
}
